import type { IAddCarePathServiceEmploymentSettings } from '@common/interfaces/addCarePathServicesSettings';
import type { IServiceEmployment } from '@frontend/components/interfaces';
import type { IServiceEmploymentSettingList } from '../../personalSettings/addRights/utils/serviceEmploymentSettingsUtils';
import { translateKey } from '../../../../translate';
import {
    getServiceEmploymentSettingListFromSettingNames,
    getServiceEmploymentSettingsLabels,
} from '../../personalSettings/addRights/utils/serviceEmploymentSettingsUtils';
import { SettingAnswerTypes } from './settingsLists';

export function getServiceEmploymentSettingsList(item: IServiceEmployment) {
    const settings: IServiceEmploymentSettingList = {};

    const serviceActivityCodes = item.serviceActivityAuthorizations.map(
        (serviceAuthorization) => serviceAuthorization.serviceActivity.customControlCode
    );

    const settingNamesList = getServiceEmploymentSettingsLabels(serviceActivityCodes);

    for (const serviceActivityAuthorization of item.serviceActivityAuthorizations) {
        settings[`activity_${serviceActivityAuthorization.serviceActivity.id}`] = {
            type: SettingAnswerTypes.boolean,
            header: translateKey('addCarePathSettingsHeaders.activities'),
            label: translateKey(
                `addCarePathSettingsLabelsServiceEmployment.${
                    serviceActivityAuthorization.canWrite ? 'canReadAndWrite' : 'canRead'
                }`,
                serviceActivityAuthorization.serviceActivity.name
            ),
        };
    }

    return {
        ...settings,
        ...getServiceEmploymentSettingListFromSettingNames(settingNamesList),
    };
}

export function getAddCarePathServiceEmploymentSettingsList(item: IAddCarePathServiceEmploymentSettings) {
    const settings: IServiceEmploymentSettingList = {};

    const serviceActivityCodes = item.serviceActivities.map((serviceActivity) => serviceActivity.customControlCode);

    const settingNamesList = getServiceEmploymentSettingsLabels(serviceActivityCodes);

    for (const profileServiceActivity of item.serviceActivities) {
        settings[`activity_${profileServiceActivity.id}`] = {
            type: SettingAnswerTypes.canReadAndOrWrite,
            header: translateKey('addCarePathSettingsHeaders.activitiesRights'),
            label: profileServiceActivity.name,
        };
    }

    return {
        ...settings,
        ...getServiceEmploymentSettingListFromSettingNames(settingNamesList),
    };
}
